export default "__VITE_ASSET__2ktTEen6__"